import { render, staticRenderFns } from "./SterilizationAttributes.vue?vue&type=template&id=70e4f38e&scoped=true&"
import script from "./SterilizationAttributes.vue?vue&type=script&lang=js&"
export * from "./SterilizationAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e4f38e",
  null
  
)

export default component.exports